import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7145
 *
 * @param {SvgIconProps} props - svg props
 */
export const FullscreenIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M5.25 10.5H3.5C3.36193 10.5 3.25 10.3881 3.25 10.25V4.5C3.25 4.22386 3.47386 4 3.75 4H10.25C10.3881 4 10.5 4.11193 10.5 4.25V5.875C10.5 6.01307 10.3881 6.125 10.25 6.125H5.5V10.25C5.5 10.3881 5.38807 10.5 5.25 10.5ZM5.2 13.5H3.5C3.36193 13.5 3.25 13.6119 3.25 13.75V19.5C3.25 19.7761 3.47386 20 3.75 20H10.25C10.3881 20 10.5 19.8881 10.5 19.75V18.0833C10.5 17.9453 10.3881 17.8333 10.25 17.8333H5.45V13.75C5.45 13.6119 5.33807 13.5 5.2 13.5ZM20.5 13.5H18.8C18.6619 13.5 18.55 13.6119 18.55 13.75V17.8666H13.75C13.6119 17.8666 13.5 17.9786 13.5 18.1166V19.75C13.5 19.8881 13.6119 20 13.75 20H20.25C20.5261 20 20.75 19.7761 20.75 19.5V13.75C20.75 13.6119 20.6381 13.5 20.5 13.5ZM18.8 10.5H20.5C20.6381 10.5 20.75 10.3881 20.75 10.25V4.5C20.75 4.22386 20.5261 4 20.25 4H13.75C13.6119 4 13.5 4.11193 13.5 4.25V5.875C13.5 6.01307 13.6119 6.125 13.75 6.125H18.55V10.25C18.55 10.3881 18.6619 10.5 18.8 10.5Z' fill={color}/>
        </SvgIcon>
    )
}

export default FullscreenIcon
